import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Link } from "react-router-dom";

const DEFAULT_IMAGE = "/assets/images/VaultAccess/no-image3.png";

const QuickViewDialog = ({ visible, onHide, product, detailLinkPrefix = "/product-detail/" }) => {
    if (!product) return null;

    return (
        <Dialog
            visible={visible}
            className="quickview-dialog"
            onHide={onHide}
            draggable={false}
            dismissableMask
            showHeader={false}
            breakpoints={{ '960px': '80vw', '641px': '95vw' }}
        >
            <div className="qv-container">
                <div className="qv-image-section">
                    <img
                        src={product.Image1 || product.IMAGEPATH || DEFAULT_IMAGE}
                        alt={product.StyleNo}
                        className="qv-main-img"
                        onError={(e) => { e.currentTarget.src = DEFAULT_IMAGE; }}
                    />
                </div>

                <div className="qv-details-section">
                    <div className="qv-heading">Quick View: </div>
                    <div className="qv-ref">
                        <label>Style No: </label>
                        <span> {product.StyleNo}</span>
                    </div>
                    <div className="qv-ref">
                        <span> {product.LineAmount || product.TotalAmount}</span>
                    </div>
                    <div className="qv-header-row">
                        <label>Product Name: </label>
                        <h2 className="qv-title">{product.Line1 || product.Shortdescription}</h2>
                    </div>

                    <hr className="qv-divider" />

                    <div className="qv-grid-info">
                        <div className="qv-info-item full-width">
                            <label>GOLD PURITY</label>
                            <span>{product.MetalQuality || "-"} / {product.MetalTone || "-"}</span>
                        </div>
                        <div className="qv-info-item full-width">
                            <label>GOLD WEIGHT</label>
                            <span>{product.TotalNetWt || "-"} G</span>
                        </div>
                        <div className="qv-info-item full-width">
                            <label>DIMENSION</label>
                            <span>{product.ItemSize || "-"}</span>
                        </div>
                    </div>

                    <div className="qv-footer">
                        <Link 
                            to={`${detailLinkPrefix}${product.Style_ID}`} 
                            className="qv-details-link"
                            onClick={onHide}
                        >
                            VIEW MORE DETAILS <span className="qv-arrow">→</span>
                        </Link>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default QuickViewDialog;
